import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'structures',
  templateUrl: './structures.view.html',
  styleUrls: ['./structures.view.scss']
})
export class StructuresView implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
